export const definedUrlFilters = [
  {
    displayValue: 'Show all',
    value: null,
  },
  {
    displayValue: 'Yes',
    value: 0,
  },
  {
    displayValue: 'No',
    value: 1,
  },
]
